<template>
  <v-toolbar
    color="primary"
    dark
    app
    clipped-left
  >
    <v-toolbar-side-icon
      v-if="isUserLoggedIn"
      @click="openDrawer"
    />

    <img
      alt="Logo"
      :src="company.logo"
      class="navbar-logo"
      :style="{ width: company.logoWidth || '50px' }"
      @click="goToLandingPage"
    >

    <v-spacer />

    <div
      v-if="!isUserLoggedIn"
      class="navbar-items"
    >
      <v-btn
        small
        flat
        @click="$router.replace({ name: 'SelectionView' })"
      >
        <!-- <v-icon>event</v-icon> -->
        Turnos
      </v-btn>
      <v-btn
        small
        flat
        @click="$router.replace({ name: 'LoginView' })"
      >
        <!-- <v-icon>account_box</v-icon> -->
        Ingresar
      </v-btn>
    </div>

    <div v-if="isUserLoggedIn">
      <div class="navbar-items">
        <v-list-tile>
          <v-list-tile-title>
            {{ user.name }}
          </v-list-tile-title>
        </v-list-tile>
      </div>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TheNavbar',
  computed: {
    ...mapState(['company']),
    ...mapGetters(['isUserLoggedIn', 'user'])
  },
  methods: {
    openDrawer () {
      if (this.$store.getters.leftDrawer) {
        this.$store.dispatch('openDrawer', { open: false })
      } else {
        this.$store.dispatch('openDrawer', { open: true })
      }
    },
    goToLandingPage () {
      window.location.href = this.company.landing
    },
    async logoutUser () {
      await this.$store.dispatch('logoutUser')
      window.sessionStorage.clear()
      await this.$router.replace({ name: 'LoginView' })
    }
  }
}
</script>

<style scoped lang="sass">
.navbar-logo
  cursor: pointer
</style>
